import regions from '../_regions.json'
import upgrades from '../_upgrades.json'
import Vue from 'vue'
import {randomRange} from '@/utils/base'

const rewardBy100 = 5
const rewardBy10 = 1

export default {
    namespaced: true,
    state: {
        regions: []
    },
    getters: {
        availableRegions (state) {
            return regions.filter(region => state.regions.findIndex(item => item.id === region.id) < 0)
        },
        isAllRegions (state) {
            return state.regions.length === regions.length
        },
        regionById: state => id => state.regions.find(region => region.id === id)
    },
    actions: {
        getRandomPlaceByRegionId (store, regionId) {
            const region = regions.find(region => region.id === regionId)
            return {
                top: randomRange(region.zone[0], region.zone[3]),
                left: randomRange(region.zone[1], region.zone[2])
            }
        },

        createRegion ({commit, rootState, dispatch}, {regionId, goodId, silence = false}) {
            const region = regions.find(region => region.id === regionId)
            const price = upgrades[0].price

            if (rootState.balance.balance >= price) {
                commit('add', {region, goodId, gameTime: rootState.control.time})
                commit('goods/add', {regionId, goodId, gameTime: rootState.control.time}, {root: true})
                dispatch('balance/remove', price, {root: true})
                dispatch('history/push', {message: `Add region ${region.title} -${price}balls`, theme: 'warn'}, {root: true})
            }

            if (!silence) {
                dispatch('control/start', null, {root: true})
            }
        },

        upgradeRegion ({state, commit, rootState, dispatch}, id) {
            const region = state.regions.find(region => region.id === id)
            const nextLevelIndex = region.levelIndex + 1
            const nextLevel = upgrades[nextLevelIndex]

            if (nextLevel && rootState.balance.balance >= nextLevel.price) {
                dispatch('balance/remove', nextLevel.price, {root: true})
                const updates = {
                    levelIndex: nextLevelIndex,
                    level: nextLevel
                }
                commit('update', {id, updates})
                dispatch('history/push', {message: `Upgrade ${region.title} -${nextLevel.price}balls`, theme: 'warn'}, {root: true})
            }
        },

        update ({state, dispatch}) {
            state.regions.forEach(region => dispatch('updateRegion', region))
        },

        updateRegion ({rootState, rootGetters, commit, dispatch}, region) {
            const time = rootState.control.time
            const fps = rootState.control.fps
            const enemy = rootGetters['enemy/enemyByRegion'](region.id)
            const minute = rootState.control.minute || 1
            const reward = rootGetters['rewards/reward'](minute)
            const deviation = rootGetters['rewards/deviation'] * 1000
            const updateTime = region.level.updateTime * 1000
            const updateRewardTime = (reward.time * 1000) + deviation

            const updates = {
                willUpdate: updateTime + deviation - (time - region.lastUpdate),
                lastUpdate: enemy ? region.lastUpdate + fps : region.lastUpdate,
                minute: minute,
                reward: {
                    ...region.reward,
                    ...reward,
                    willUpdate: updateRewardTime - (time - region.reward.lastUpdate) + (enemy ? fps : 0),
                    lastUpdate: enemy ? region.reward.lastUpdate + fps : region.reward.lastUpdate,
                    updateRewardTime
                }
            }

            // Получение балов
            if (updates.reward.willUpdate <= 0) {
                updates.reward.lastUpdate = time
                updates.reward.willUpdate = updateRewardTime
                dispatch('history/push', {message: `${region.title} +${region.reward.balls}BALL for ${updateRewardTime/1000}sec`, theme: 'success'}, {root: true})
                dispatch('balance/add', region.reward.balls, {root: true})
            }

            // обновление очков захвата
            if (updates.willUpdate <= 0 && region.progress !== 100) {
                updates.progress = region.progress + 1
                updates.lastUpdate = time
                updates.willUpdate = updateTime
                dispatch('history/push', {message: `${region.title} +1% for ${region.level.updateTime}sec`, theme: 'success'}, {root: true})
                if (updates.progress % 10 === 0) {
                    dispatch('balance/add', rewardBy10, {root: true})
                    dispatch('history/push', {message: `${region.title} +${rewardBy10}ball for every 10%`, theme: 'success'}, {root: true})
                }
                if (updates.progress === 100) {
                    dispatch('balance/add', rewardBy100, {root: true})
                    dispatch('history/push', {message: `${region.title} +${rewardBy100}ball for 100%`, theme: 'success'}, {root: true})
                }
            }

            commit('update', {id: region.id, updates})
        },

        reset ({commit}) {
            commit('reset')
        }
    },
    mutations: {
        add (state, {region, goodId, gameTime}) {
            state.regions.push({
                ...region,
                goodId: goodId,
                lastUpdate: gameTime,
                willUpdate: upgrades[0].updateTime * 1000,
                progress: 0,
                createdAt: gameTime,
                minute: 1,
                levelIndex: 0,
                level: upgrades[0],
                reward: {
                    lastUpdate: gameTime
                }
            })
        },

        update (state, {id, updates = {}}) {
            const regionIndex = state.regions.findIndex(region => region.id === id)
            const region = state.regions[regionIndex]
            Vue.set(state.regions, regionIndex, {
                ...region,
                ...updates
            })
        },

        reset (state) {
            state.regions = []
        }
    }
}
